module.exports = __webpack_public_path__ + "ad7dcd6568c09cfb9f56bd39c21e7464.png";